<app-navbar [helpUrl]="helpUrl"></app-navbar>
@if (noticeContent) {
  <app-notice></app-notice>
}
<app-asda-breadcrumb [breadcrumbs]="breadcrumbs"></app-asda-breadcrumb>

<router-outlet></router-outlet>
